"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.hasCookies = hasCookies;
var cookie = _interopRequireWildcard(require("cookie"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var prefix = "lS_";
var CookieStorage = exports["default"] = /*#__PURE__*/function () {
  function CookieStorage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, CookieStorage);
    this.cookieOptions = Object.assign({
      path: "/"
    }, options);
    prefix = options.prefix === undefined ? prefix : options.prefix;
  }
  return _createClass(CookieStorage, [{
    key: "getItem",
    value: function getItem(key) {
      var cookies = cookie.parse(document.cookie);
      if (!cookies || !cookies[prefix + key]) {
        return null;
      }
      return cookies[prefix + key];
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      document.cookie = cookie.serialize(prefix + key, value, this.cookieOptions);
      return value;
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      var options = Object.assign({}, this.cookieOptions, {
        maxAge: -1
      });
      document.cookie = cookie.serialize(prefix + key, "", options);
      return null;
    }
  }, {
    key: "clear",
    value: function clear() {
      var cookies = cookie.parse(document.cookie);
      for (var key in cookies) {
        if (key.indexOf(prefix) === 0) {
          this.removeItem(key.substr(prefix.length));
        }
      }
      return null;
    }
  }]);
}();
function hasCookies() {
  var storage = new CookieStorage();
  try {
    var TEST_KEY = "__test";
    storage.setItem(TEST_KEY, "1");
    var value = storage.getItem(TEST_KEY);
    storage.removeItem(TEST_KEY);
    return value === "1";
  } catch (e) {
    return false;
  }
}